<div class="ki-fehler" role="alert" data-testid="ki-fehler">
  <mat-icon class="ki-fehler__icon" aria-hidden="true">close</mat-icon>
  <span class="ki-fehler__text">{{ text() }}</span>
  @if (erneutAnbieten()) {
    <button
      mat-stroked-button
      type="button"
      class="ki-fehler__erneut"
      data-testid="ki-fehler-erneut"
      (click)="erneut.emit()"
    >
      {{ 'ki.fehler.erneut' | translate }}
    </button>
  }
</div>
